export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const FETCH_AUTOCARE_BUDGET = 'FETCH_AUTOCARE_BUDGET';
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const SUCCESSFUL_FETCHED_HISTORY_BUDGET = 'SUCCESSFUL_FETCHED_HISTORY_BUDGET';
export const SUCCESSFUL_FETCHED_CLIENT_REQUEST_BUDGET = 'SUCCESSFUL_FETCHED_CLIENT_REQUEST_BUDGET';
export const SUCCESSFUL_FETCHED_AUTOCARE_BUDGET = 'SUCCESSFUL_FETCHED_AUTOCARE_BUDGET';
export const SAVE_ACTUAL_BUDGET = 'SAVE_ACTUAL_BUDGET';
export const ADD_SERVICELINE = 'ADD_SERVICELINE';
export const REMOVE_SERVICELINE = 'REMOVE_SERVICELINE';
export const SAVED_AUTOCARE_BUDGET = 'SAVED_AUTOCARE_BUDGET';
export const CLEAN_AUTOCARE_BUDGET_STORE = 'CLEAN_AUTOCARE_BUDGET_STORE';
export const TASK_FETCH_SUCCESS = 'TASK_FETCH_SUCCESS';
export const BUDGET_UPDATE_SUCCESS = 'BUDGET_UPDATE_SUCCESS';
export const FETCH_TASK_STATUS_SUCCESS = 'FETCH_TASK_STATUS_SUCCESS';
export const CLEAN_BUDGET_STORE = 'CLEAN_BUDGET_STORE';
export const ADD_NEW_SERVICES_SUCCESS = 'ADD_NEW_SERVICES_SUCCESS';
export const LOAD_CLIENT_BY_PLATE = 'LOAD_CLIENT_BY_PLATE';
export const CHANGE_REFRESH_POSTLOAD = 'CHANGE_REFRESH_POSTLOAD';
export const FETCHED_COMPLETED_BUDGETS_SUCCESS = 'FETCHED_COMPLETED_BUDGETS_SUCCESS'
export const SAVE_NEW_SERVICES_LINES_SUCCESS = 'SAVE_NEW_SERVICES_LINES_SUCCESS'
export const PDF_UPLOADED_SUCCESSFULLY = 'PDF_UPLOADED_SUCCESSFULLY';
export const SERVICE_SENT_SUCCESSFULLY = 'SERVICE_SENT_SUCCESSFULLY';
export const FETCHED_BUDGETS_SUCCESS = 'FETCHED_BUDGETS_SUCCESS';
export const SERVICE_REMOVED_SUCCESSFULLY = 'SERVICE_REMOVED_SUCCESSFULLY';
export const NO_CHARGE_TOGGLED_SUCCESSFULLY = 'NO_CHARGE_TOGGLED_SUCCESSFULLY';
export const PRICE_CHANGED_SUCCESSFULLY = 'PRICE_CHANGED_SUCCESSFULLY';
export const CHANGE_REFRESH_POSTLOAD_CAR = 'CHANGE_REFRESH_POSTLOAD_CAR';
export const CHANGE_REFRESH_DISMISS = 'CHANGE_REFRESH_DISMISS';


// WEBPACK FOOTER //
// ./src/actionTypes/budgets.js